export const namespaced = true;

import AskTeacherService from '@/services/AskTeacherService.js';
import first from 'lodash/first';

export const state = {
  inClassAskTeachers: [],
  outClassAskTeachers: [],
  notificationAskTeachers: [],
  historyAskTeachers: [],
  askTeacher: {},
};

export const mutations = {
  SET_IN_CLASS_ASK_TEACHERS(state, askTeachers) {
    state.inClassAskTeachers = askTeachers;
  },
  SET_OUT_CLASS_ASK_TEACHERS(state, askTeachers) {
    state.outClassAskTeachers = askTeachers;
  },
  SET_NOTIFICATION_ASK_TEACHERS(state, askTeachers) {
    state.notificationAskTeachers = askTeachers;
  },
  SET_HISTORY_ASK_TEACHERS(state, askTeachers) {
    state.historyAskTeachers = askTeachers;
  },
  SET_ASK_TEACHER(state, askTeacher) {
    state.askTeacher = askTeacher;
  },
  REPLY_TAUGHT_ASK_TEACHER(state, payload) {
    payload.askTeachers.splice(payload.index, 1);
    state.historyAskTeachers.push(payload.askTeacher);
  },
  REPLY_GAVE_A_HINT_ASK_TEACHER(state, payload) {
    payload.askTeachers.splice(payload.index, 1);
    state.historyAskTeachers.push(payload.askTeacher);
  },
  REPLY_STUDENT_SELF_SOLVED_ASK_TEACHER(state, payload) {
    payload.askTeachers.splice(payload.index, 1);
    state.historyAskTeachers.push(payload.askTeacher);
  },
};

export const actions = {
  clearInClassAskTeachers({ commit }) {
    commit('SET_IN_CLASS_ASK_TEACHERS', []);
  },
  fetchInClassAskTeachers({ commit }, type) {
    return AskTeacherService.all({ type, months: 3 }).then((response) => {
      const askTeachers = storeBookPartAndChapterName(response.data);

      commit('SET_IN_CLASS_ASK_TEACHERS', askTeachers);
    });
  },
  clearOutClassAskTeachers({ commit }) {
    commit('SET_OUT_CLASS_ASK_TEACHERS', []);
  },
  fetchOutClassAskTeachers({ commit }, type) {
    return AskTeacherService.all({ type, months: 3 }).then((response) => {
      const askTeachers = storeBookPartAndChapterName(response.data);

      commit('SET_OUT_CLASS_ASK_TEACHERS', askTeachers);
    });
  },
  clearNotificationAskTeachers({ commit }) {
    commit('SET_NOTIFICATION_ASK_TEACHERS', []);
  },
  fetchNotificationAskTeachers({ commit }, type) {
    return AskTeacherService.all({ type, months: 3 }).then((response) => {
      const askTeachers = storeBookPartAndChapterName(response.data);

      commit('SET_NOTIFICATION_ASK_TEACHERS', askTeachers);
    });
  },
  clearHistoryAskTeachers({ commit }) {
    commit('SET_HISTORY_ASK_TEACHERS', []);
  },
  fetchHistoryAskTeachers({ commit }, type) {
    return AskTeacherService.all({ type, months: 3 }).then((response) => {
      const askTeachers = storeBookPartAndChapterName(response.data);

      commit('SET_HISTORY_ASK_TEACHERS', askTeachers);
    });
  },
  fetchAskTeacher({ commit }, id) {
    return AskTeacherService.get(id).then((response) => {
      const askTeacher = first(storeBookPartAndChapterName([response.data]));
      commit('SET_ASK_TEACHER', askTeacher);
      return askTeacher;
    });
  },
  replyTaughtAskTeacher({ commit }, payload) {
    payload.askTeacher.handledType = 'taught';
    payload.askTeacher.handledDatetime = Date.now(); // For display locally only
    return AskTeacherService.reply(payload.askTeacher.id, { handledType: payload.askTeacher.handledType }).then(() => {
      let statePayload = {
        index: payload.askTeachers.findIndex((item) => item.id == payload.askTeacher.id),
        askTeachers: payload.askTeachers,
        askTeacher: payload.askTeacher,
      };
      commit('REPLY_TAUGHT_ASK_TEACHER', statePayload);
    });
  },
  replyGaveAHintAskTeacher({ commit }, payload) {
    payload.askTeacher.handledType = 'gave_a_hint';
    payload.askTeacher.handledDatetime = Date.now(); // For display locally only
    return AskTeacherService.reply(payload.askTeacher.id, { handledType: payload.askTeacher.handledType }).then(() => {
      let statePayload = {
        index: payload.askTeachers.findIndex((item) => item.id == payload.askTeacher.id),
        askTeachers: payload.askTeachers,
        askTeacher: payload.askTeacher,
      };
      commit('REPLY_GAVE_A_HINT_ASK_TEACHER', statePayload);
    });
  },
  replyStudentSelfSolvedAskTeacher({ commit }, payload) {
    payload.askTeacher.handledType = 'self_solved';
    payload.askTeacher.handledDatetime = Date.now(); // For display locally only
    return AskTeacherService.reply(payload.askTeacher.id, { handledType: payload.askTeacher.handledType }).then(() => {
      let statePayload = {
        index: payload.askTeachers.findIndex((item) => item.id == payload.askTeacher.id),
        askTeachers: payload.askTeachers,
        askTeacher: payload.askTeacher,
      };
      commit('REPLY_STUDENT_SELF_SOLVED_ASK_TEACHER', statePayload);
    });
  },
};

export const getters = {
  getInClassAskTeacherById: (state) => (id) => {
    return state.inClassAskTeachers.find((item) => item.id == id);
  },
  getOutClassAskTeacherById: (state) => (id) => {
    return state.outClassAskTeachers.find((item) => item.id == id);
  },
  getNotificationAskTeacherById: (state) => (id) => {
    return state.notificationAskTeachers.find((item) => item.id == id);
  },
  getHistoryAskTeacherById: (state) => (id) => {
    return state.historyAskTeachers.find((item) => item.id == id);
  },
  totalInClassAskTeachers: (state) => {
    return state.inClassAskTeachers.length;
  },
  totalOutClassAskTeachers: (state) => {
    return state.outClassAskTeachers.length;
  },
  totalNotificationAskTeachers: (state) => {
    return state.notificationAskTeachers.length;
  },
  totalHistoryAskTeachers: (state) => {
    return state.historyAskTeachers.length;
  },
};

// PRIVATE

const storeBookPartAndChapterName = (askTeachers) => {
  // Set bookPartName and bookChapterAndBigQuestion fields right under the askTeacher to make search work.
  // To make the search work, item[key] === value, but we cannot use the same key in multiple fields.
  // The key "book" is already used to show bookName, we cannot use key "book" to show bookPartName and bookChapterAndBigQuestion
  // Thus, we put these two values right under the askTeacher object.
  for (const askTeacher of askTeachers) {
    askTeacher.bookPartName = askTeacher.bookPart.name;
    let chapter = askTeacher.bookChapter ? askTeacher.bookChapter.name : '';
    let bigQuestion = askTeacher.bookBigQuestion ? askTeacher.bookBigQuestion.name : '';
    askTeacher.bookChapterAndBigQuestion = chapter + '・大問' + bigQuestion;
  }

  return askTeachers;
};
